/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import OtpVerification from "./OtpVerification.container";

export default OtpVerification;
